/**! registered/index */

import "../polyfills"
import "@app/main"
